import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

// Routes where the header is intentionally hidden (full-screen or self-contained pages)
const HEADER_HIDDEN_ROUTES = new Set([
  '/',
  '/phaser',
  '/wedding-rsvp',
  '/bridal-shower-questions',
]);

// Routes that use a dark twilight palette — header icons need a light tint there.
const TWILIGHT_ROUTES = new Set([
  '/challenge',
]);

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'angular-firebase';
  active = false;

  private routerSub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit() {
    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const path = event.urlAfterRedirects.split('?')[0];
      this.active = !HEADER_HIDDEN_ROUTES.has(path);
      document.body.classList.toggle('theme-twilight', TWILIGHT_ROUTES.has(path));
    });
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
    document.body.classList.remove('theme-twilight');
  }
}
